import { Heading, Box, Image, Flex, ListItem, List, Text } from '@chakra-ui/react';
import BlogLayout from '../Blog/BlogLayout';


const NewGrad2026 = () => {

    return (
        
        <BlogLayout>
            <Heading align="center" fontSize="2.5rem" mt="20mm">
                2026 Job Applications and Interview Experiences
            </Heading>
            <br />
            <br />
            <Heading align="center">
                Aug 2025 - April 2026
            </Heading>

            <br/>
            <Box mx="15%" textAlign="center">
                <Image 
                    src="images/Logos/faangLogo.JPG" 
                    alt="new grad cover photo"  
                    mt="20px" 
                    w={{ base: "350px", sm: "80%" }}  
                    minWidth="250px" 
                    maxW="45%"
                    h="auto" 
                    display="block"
                    mx="auto"
                    borderRadius="15px"
                />
                <Text mt="4" fontStyle="italic"></Text>
            </Box>
            <br/>

            <Box textAlign="left" mt="30px" mx="15%" fontWeight="medium" lineHeight="2.0">
                Hi there! I'm excited to share an overview of my 2026 new grad recruitment journey.
                Here, I’ll walk you through the recruitment processes for the some companies I applied to or interviewed with, along with my personal insights throughout. 
                In total, I submitted 71 applications, all for software engineering roles. 
                I hope my experiences can offer some helpful perspective on the recruiting process, but feel free to reach out if you have any questions about anything!
            </Box>
            <Box textAlign="left" mt="60px" mx="15%" fontWeight="medium" lineHeight="2.0">
                <Box textAlign="left" fontSize="1.5em" fontWeight="bold">
                    Applied Intuition
                </Box>
                <Box mx="0%" display="flex" justifyContent="flex-start">
                    <Image 
                        src="images/Logos/appliedintuition.jpg"
                        alt="Applied Intuition Logo"
                        mt="20px" 
                        w={{ base: "350px", sm: "30%" }}
                        minWidth="200px"  
                        maxW="30%" 
                        h="auto" 
                        display="block"
                        borderRadius= "15px"
                    />
                </Box>
                <br/>
                <Flex textAlign="left" fontSize="1.0em" alignItems="center">
                    <Box fontWeight="bold" mr={6}>
                        Position:
                    </Box>
                    <Box fontWeight="medium">
                        Software Engineer - New Grad
                    </Box>

                </Flex>
                <br/>
                <Flex textAlign="left" fontSize="1.0em" alignItems="center">
                    <Box fontWeight="bold" mr={6}>
                        Location:
                    </Box>
                    <Box fontWeight="medium">
                        Mountain View, CA
                    </Box>

                </Flex>

                <br/>
                <Flex textAlign="left" fontSize="1.0em" >
                    <Box fontWeight="bold" mr={6} >
                        Timeline: 
                    </Box>
                    <Box fontWeight="medium">
                        Applied online without referral (08/12) <span>&rarr;&nbsp;</span> 
                        Online recruiter call (08/26) <span>&rarr;&nbsp;</span> 
                        Completed OA (08/29) <span>&rarr;&nbsp;</span> 
                        Online 45 minute 1st Technical Interview (09/04) <span>&rarr;&nbsp;</span> 
                        <b>Rejected (09/09)</b>
                        
                    </Box>
                </Flex>
                <br/>
                <Flex textAlign="left" fontSize="1.0em">
                    <Box fontWeight="bold" mr={6}>
                        Thoughts:
                    </Box>
                    <Box fontWeight="medium">
                        This was my first recruitment process for the new grad season and I was pretty excited to get the chance to interview with Applied Intuition.
                        I applied online through their careers page without a referral.
                        After about two weeks, I received a recruiter call where we discussed my background and the role. Shortly after, I was given an online assessment (OA) to complete within 3 days.
                        The OA consisted of one coding problem on CoderPad, I'd say around a medium-hard difficulty. I completed the OA in about an hour and submitted it.
                        <br/>
                        <br/>
                        The technical interview was a 45-min with a SWE on the team. We went through a coding problem together,
                        and I was able to make some progress on it throughout the session. I was thrown a bit off guard because
                        it wasn't a typical leetcode-style question, but more of a design problem that required some coding.
                        After the interview, i didn't expect to move on, and I got a call from my recruiter a few days 
                        after saying that I wasn't moving on. 
                        <br/>
                        <br/>
                        While I was disappointed, I appreciated the opportunity to interview and learn from the experience.
                        Overall, I felt that the interviewers were friendly and supportive, which helped ease my nerves. The company also 
                        moved really fast and got back to me quickly, which I appreciated. 
                    </Box>
                </Flex>
            </Box>



            <Box textAlign="left" mt="60px" mx="15%" fontWeight="medium" lineHeight="2.0">
                <Box textAlign="left" fontSize="1.5em" fontWeight="bold">
                    Anduril Industries
                </Box>
                <Box mx="0%" display="flex" justifyContent="flex-start">
                    <Image 
                        src="images/Logos/andurilLogo.PNG"
                        alt="Anduril Industries Logo"
                        mt="20px" 
                        w={{ base: "350px", sm: "30%" }}
                        minWidth="200px"  
                        maxW="30%" 
                        h="auto" 
                        display="block"
                        borderRadius= "15px"
                    />
                </Box>
                <br/>
                <Flex textAlign="left" fontSize="1.0em" alignItems="center">
                    <Box fontWeight="bold" mr={6}>
                        Position:
                    </Box>
                    <Box fontWeight="medium">
                        Early Career Software Engineer
                    </Box>

                </Flex>
                <br/>
                <Flex textAlign="left" fontSize="1.0em" alignItems="center">
                    <Box fontWeight="bold" mr={6}>
                        Location:
                    </Box>
                    <Box fontWeight="medium">
                        Boston, MA
                    </Box>

                </Flex>

                <br/>
                <Flex textAlign="left" fontSize="1.0em">
                    <Box fontWeight="bold" mr={6}>
                        Timeline:
                    </Box>
                    <Box fontWeight="medium">
                        Applied online without referral (08/11) <span>&rarr;&nbsp;</span> 
                        Online recruiter call (09/09) <span>&rarr;&nbsp;</span> 
                        <b>Rejected (09/10)</b>
                        
                    </Box>
                </Flex>
                <br/>
                <Flex textAlign="left" fontSize="1.0em">
                    <Box fontWeight="bold" mr={6}>
                        Thoughts:
                    </Box>
                    <Box fontWeight="medium">
                        I applied online through their careers page without a referral.
                        After about two weeks, I received a recruiter call where we discussed my background and the role. 
                        However, the initial recruiter call was delayed by a few weeks due to their internal scheduling, so I had to wait a bit longer than expected.
                        <br/>
                        <br/>
                        Not a great look, because when I finally had the call, it seemed like they already went
                        through technical rounds with other candidates. Rejection came shortly after.
                        
                    </Box>
                </Flex>
            </Box>

            <Box textAlign="left" mt="60px" mx="15%" fontWeight="medium" lineHeight="2.0">
                <Box textAlign="left" fontSize="1.5em" fontWeight="bold">
                    Adobe
                </Box>
                <Box mx="0%" display="flex" justifyContent="flex-start">
                    <Image 
                        src="images/Logos/AdobeLogo.png"
                        alt="Adobe Logo"
                        mt="20px" 
                        w={{ base: "350px", sm: "30%" }}
                        minWidth="200px"  
                        maxW="30%" 
                        h="auto" 
                        display="block"
                        borderRadius= "15px"
                    />
                </Box>
                <br/>
                <Flex textAlign="left" fontSize="1.0em" alignItems="center">
                    <Box fontWeight="bold" mr={6}>
                        Position:
                    </Box>
                    <Box fontWeight="medium">
                        2026 University Graduate - Software Engineer
                    </Box>

                </Flex>
                <br/>
                <Flex textAlign="left" fontSize="1.0em" alignItems="center">
                    <Box fontWeight="bold" mr={6}>
                        Location:
                    </Box>
                    <Box fontWeight="medium">
                        San Jose, CA
                    </Box>

                </Flex>

                <br/>
                <Flex textAlign="left" fontSize="1.0em">
                    <Box fontWeight="bold" mr={6}>
                        Timeline:
                    </Box>
                    <Box fontWeight="medium">
                        Applied online without referral (08/26) <span>&rarr;&nbsp;</span> 
                        Received / Completed OA (10/30) <span>&rarr;&nbsp;</span> 
                        Received Final Round Invitation (11/13) <span>&rarr;&nbsp;</span> 
                        Completed Final Round Technical + Behavioral Interviews (11/18-11/20) <span>&rarr;&nbsp;</span>
                        <b>Rejected (12/17)</b> 
                        
                        
                    </Box>
                </Flex>
                <br/>
                <Flex textAlign="left" fontSize="1.0em">
                    <Box fontWeight="bold" mr={6}>
                        Thoughts:
                    </Box>
                    <Box fontWeight="medium">
                        I applied online through the Adobe careers page after seeing the job posting online.
                        After submitting my application, I received the OA on 10/30 and completed it the same day. 
                        I was invited to final rounds on 11/13, with interviews scheduled from 11/18–11/20 across three different teams.
                        <br/>
                        <br/>
                        The final round consisted of one technical interview and one behavioral interview per team. I interviewed with 3 teams: the Adobe Journey Optimizer team, Adobe Unified Platform team, and Adobe Analytics team.
                        One of my technical rounds was a LeetCode medium-difficulty hashset problem, followed by scaling follow-ups and time complexity analysis. 
                        The other technical round included an easy string-manipulation problem with medium SQL problem follow-up problems. 
                        The last technical round included a ML problem of medium difficulty that involved applying foundation of modern machine learning optimization and implementing the exact algorithms.
                        Across all rounds, many questions focused on my Walmart Labs internship, especially the multi-agent LLM evaluation pipeline, session management system, and how I validated outputs at scale.
                        <br/>
                        <br/>
                        {/* I had strong conversations with all teams, but I felt the closest technical alignment with the Adobe Journey Optimizer B2B and I loved the conversation I had about AI with the team manager. 
                        I also enjoyed talking to the Adobe Unified Platform team, and it seems like their technical interview aligned with what I am looking for in a full-time role. 
                        The Adobe Analytics team was definitely a different-style interview process because of the technical interview asking more ML-based question rather than leetcode-style, 
                        but I also really enjoyed talking to the team manager during the behavioral interview. However, the team noted most roles were hiring for Lehi, Utah rather than San Jose.
                        <br/>
                        <br/> */}
                        Overall, it was a great interview experience, and I appreciated how open and engaging the conversations were across all teams. 
                        Although they rejected me a month after, there wasn't much else I thought I could do, and I was glad about my performance. 
                    </Box>
                </Flex>
            </Box>

            <Box textAlign="left" mt="60px" mx="15%" fontWeight="medium" lineHeight="2.0">
                <Box textAlign="left" fontSize="1.5em" fontWeight="bold">
                    Robinhood
                </Box>
                <Box mx="0%" display="flex" justifyContent="flex-start">
                    <Image 
                        src="images/Logos/RobinhoodLogo.png"
                        alt="Robinhood Logo"
                        mt="20px" 
                        w={{ base: "350px", sm: "30%" }}
                        minWidth="200px"  
                        maxW="30%" 
                        h="auto" 
                        display="block"
                        borderRadius= "15px"
                    />
                </Box>
                <br/>
                <Flex textAlign="left" fontSize="1.0em" alignItems="center">
                    <Box fontWeight="bold" mr={6}>
                        Position:
                    </Box>
                    <Box fontWeight="medium">
                        Software Engineering Intern, Backend (Summer 2026)
                    </Box>

                </Flex>
                <br/>
                <Flex textAlign="left" fontSize="1.0em" alignItems="center">
                    <Box fontWeight="bold" mr={6}>
                        Location:
                    </Box>
                    <Box fontWeight="medium">
                        Menlo Park, CA
                    </Box>

                </Flex>

                <br/>
                <Flex textAlign="left" fontSize="1.0em">
                    <Box fontWeight="bold" mr={6}>
                        Timeline:
                    </Box>
                    <Box fontWeight="medium">
                        Applied online without referral (09/22) <span>&rarr;&nbsp;</span> 
                        Received OA (10/20) <span>&rarr;&nbsp;</span>
                        Completed OA (10/22) <span>&rarr;&nbsp;</span>
                        Recruiter Phone Screen (11/04) <span>&rarr;&nbsp;</span>
                        Final Round Behavioral + Technical Interviews (11/14) <span>&rarr;&nbsp;</span>
                        <b>RECEIVED OFFER! (12/01)</b>
                        
                    </Box>
                </Flex>
                <br/>
                <Flex textAlign="left" fontSize="1.0em">
                    <Box fontWeight="bold" mr={6}>
                        Thoughts:
                    </Box>
                    <Box fontWeight="medium">
                        I applied to Robinhood via their careers page after seeing the job posting online.
                        Yes, this is one of just a few internships I applied to for Summer 2026, but I figured it was worth trying out since Robinhood was a company I was very interested in.
                        About a month after applying, I received an email to schedule an online assessment (OA).
                        <br/>
                        <br/>
                        I had my recruiter phone screen after about two weeks of submitting my OA.
                        The recruiter screen was a behavioral-focused interview where we discussed my background, experiences, and motivations for applying to Robinhood.
                        A week later, I was invited to the final round interviews, which consisted of one behavioral and one technical interview.
                        <br/>
                        <br/>
                        The technical interview was a 45-minute coding session where I was given one medium difficulty problem to solve.
                        The behavioral interview was a 30-minute session where we discussed my past expereriences more in depth and some situational questions.
                        I thought the entire interview process was very smooth with timely updates and interviewers who
                        genuinely seemed interested in getting to know me and my experiences. I was pretty surprised that they 
                        extended an offer a few weeks later, but I was also happy about my performance throughout the interviews.
                    </Box>
                </Flex>
            </Box>

            <Box textAlign="left" mt="60px" mx="15%" fontWeight="medium" lineHeight="2.0">
                <Box textAlign="left" fontSize="1.5em" fontWeight="bold">
                    Google
                </Box>
                <Box mx="0%" display="flex" justifyContent="flex-start">
                    <Image 
                        src="images/Logos/GoogleLogo.jpeg"
                        alt="Google Logo"
                        mt="20px" 
                        w={{ base: "350px", sm: "30%" }}
                        minWidth="200px"  
                        maxW="30%" 
                        h="auto" 
                        display="block"
                        borderRadius= "15px"
                    />
                </Box>
                <br/>
                <Flex textAlign="left" fontSize="1.0em" alignItems="center">
                    <Box fontWeight="bold" mr={6}>
                        Position:
                    </Box>
                    <Box fontWeight="medium">
                        Software Engineer, Early Career, Campus, 2026
                    </Box>

                </Flex>
                <br/>
                <Flex textAlign="left" fontSize="1.0em" alignItems="center">
                    <Box fontWeight="bold" mr={6}>
                        Location:
                    </Box>
                    <Box fontWeight="medium">
                        Mountain View, CA
                    </Box>

                </Flex>

                <br/>
                <Flex textAlign="left" fontSize="1.0em">
                    <Box fontWeight="bold" mr={6}>
                        Timeline:
                    </Box>
                    <Box fontWeight="medium">
                        Applied online without referral (10/16) <span>&rarr;&nbsp;</span> 
                        Received / Completed OA (11/12) <span>&rarr;&nbsp;</span> 
                        Received First Round Interview Invitation (11/13) <span>&rarr;&nbsp;</span> 
                        Completed First Round Interviews (11/21 + 12/11) <span>&rarr;&nbsp;</span>
                        Moved on to Round 2 Onsite Interviews (12/11) <span>&rarr;&nbsp;</span>
                        Completed Onsite Interviews (02/06) <span>&rarr;&nbsp;</span>
                        Moved onto Team Matching (03/19) <span>&rarr;&nbsp;</span>
                        
                    </Box>
                </Flex>
                <br/>
                <Flex textAlign="left" fontSize="1.0em">
                    <Box fontWeight="bold" mr={6}>
                        Thoughts:
                    </Box>
                    <Box fontWeight="medium">
                        I cold applied to Google online through the Google careers page. 
                        I wasn't expecting to hear back, but I believe attending one of the Google on-campus events helped me get past the initial resume screen.  
                        <br/>
                        <br/>
                        To start, this interview process was definitely the longest and there were some delays between each interview round as well. 
                        The first round consisted of a technical and behavioral interview, and I was able to move on to the second round after about a month.
                        The second round was an onsite interview that included 2 technical interviews. These technical interviews were a mix of data structure / algorithm questions.
                         <br/>
                         <br/>
                         A month after the second round onsites, I finally moved on to the team matching phase.
                        
                    </Box>
                </Flex>
            </Box>

            <Box textAlign="left" mt="60px" mx="15%" fontWeight="medium" lineHeight="2.0">
                <Box textAlign="left" fontSize="1.5em" fontWeight="bold">
                    Bloomberg
                </Box>
                <Box mx="0%" display="flex" justifyContent="flex-start">
                    <Image 
                        src="images/Logos/BloombergLogo.png"
                        alt="Bloomberg Logo"
                        mt="20px" 
                        w={{ base: "350px", sm: "30%" }}
                        minWidth="200px"  
                        maxW="30%" 
                        h="auto" 
                        display="block"
                        borderRadius= "15px"
                    />
                </Box>
                <br/>
                <Flex textAlign="left" fontSize="1.0em" alignItems="center">
                    <Box fontWeight="bold" mr={6}>
                        Position:
                    </Box>
                    <Box fontWeight="medium">
                        2026 Software Engineer - New York
                    </Box>

                </Flex>
                <br/>
                <Flex textAlign="left" fontSize="1.0em" alignItems="center">
                    <Box fontWeight="bold" mr={6}>
                        Location:
                    </Box>
                    <Box fontWeight="medium">
                        New York, NY
                    </Box>

                </Flex>

                <br/>
                <Flex textAlign="left" fontSize="1.0em">
                    <Box fontWeight="bold" mr={6}>
                        Timeline:
                    </Box>
                    <Box fontWeight="medium">
                        Applied via Handshake without referral (10/28) <span>&rarr;&nbsp;</span> 
                        Completed First Round Technical Screen (11/06) <span>&rarr;&nbsp;</span> 
                       <b>Rejected (11/11)</b>
                        
                    </Box>
                </Flex>
                <br/>
                <Flex textAlign="left" fontSize="1.0em">
                    <Box fontWeight="bold" mr={6}>
                        Thoughts:
                    </Box>
                    <Box fontWeight="medium">
                        I applied to Bloomberg via Handshake, but I remember seeing that the job posting was already on Handshake for 2 weeks. 
                        A few weeks after applying, I received an email to schedule a technical phone screen.
                        The technical screen was a 45-minute coding interview where I was given one medium difficulty problem to solve. 
                        The problem wasn't a traditional implement a function, it was more of an OOP design question that required implementing a class.
                        <br/>
                        <br/>
                        I was rejected after first round … I thought that I did the interview well because I was able to solve the problem. 
                        Looking back, if there were areas to improve upon, I would say that I should have spent more time walking through my approach instead of going into the coding relatively fast. 
                        I also would have stated a few more edge cases, walked through my solution so that my interviewer was on the same page, and then start implementing the solution. 
                        We didn’t get to follow-up questions such as time / space complexity because I got the working optimal solution right as time expired. 
                        Good interview experience + practice nonetheless.
                    </Box>
                </Flex>
            </Box>


            <Box textAlign="left" mt="30px" mx="15%" fontWeight="medium" lineHeight="2.0">
                <Box textAlign="left" fontSize="1.5em" fontWeight="bold">
                    Concluding Thoughts
                </Box>
                Overall, I applied to 66 New Grad roles for 2026 and 5 internship roles for companies that are known not to hire new graduate software engineers. 
                Some other companies I applied to that I didn't detail above include:
                OpenAI, Ramp, Roblox, Databricks, Microsoft, Meta, Notion, Pinterest, Figma, Salesforce, Doordash, NVIDIA, Apple, and Netflix. 
                <br/>
                <br/>
                Out of the 66 new grad roles, I received 13 online assessment / recruiter screens, 4 first round interviews, and 2 final round interviews (and 1 offer!).
                <br/>
                Out of the 5 internship roles, I received 1 online assessments / recruiter screens, 1 first round interview, and 1 final round interview (and 1 offer!).
            </Box>
            <br/>

            <Box textAlign="left" mt="30px" mx="15%" fontWeight="medium" lineHeight="2.0">
                Let me know if you have any questions about any of the above recruitment processes and I will try to answer to my best knowledge and memory!
            </Box>
            <br/>
            <br/>

        </BlogLayout>
    );
};

export default NewGrad2026